import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { MANUAL_KEYS } from '../reportingFollowUpConstants';
import { AmountInput, RowLabel, SectionCard, TrackingFields, ValuesTable } from './SectionParts';

const KEYS = MANUAL_KEYS.NI_WITHHOLDING;

const NiWithholdingSection = ({ periodLabel, fileNumber, tracking, onManualChange, onTrackingChange, direction }) => {
    const { t } = useTranslation();
    const manual = tracking.manualValues || {};

    return (
        <SectionCard title={t('FollowUpNiWithholdingTitle')} fileNumber={fileNumber}>
            <ValuesTable periodLabel={periodLabel} columns={[t('FollowUpReport')]}>
                <RowLabel>{t('FollowUpNumberOfEmployees')}</RowLabel>
                <AmountInput
                    value={manual[KEYS.numberOfEmployees]}
                    onChange={(value) => onManualChange(KEYS.numberOfEmployees, value)}
                />

                <RowLabel>{t('FollowUpNiWithholdingToPay')}</RowLabel>
                <AmountInput
                    value={manual[KEYS.amountToPay]}
                    onChange={(value) => onManualChange(KEYS.amountToPay, value)}
                    total
                />
            </ValuesTable>

            <TrackingFields tracking={tracking} onChange={onTrackingChange} direction={direction} />
        </SectionCard>
    );
};

NiWithholdingSection.propTypes = {
    periodLabel: PropTypes.string,
    fileNumber: PropTypes.string,
    tracking: PropTypes.object.isRequired,
    onManualChange: PropTypes.func.isRequired,
    onTrackingChange: PropTypes.func.isRequired,
    direction: PropTypes.string,
};

export default NiWithholdingSection;
